export const share2 = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Frame">
      <path
        id="Vector"
        d="M9.125 13.5V6.36875L6.85 8.64375L5.625 7.375L10 3L14.375 7.375L13.15 8.64375L10.875 6.36875V13.5H9.125ZM4.75 17C4.26875 17 3.85677 16.8286 3.51406 16.4859C3.17135 16.1432 3 15.7312 3 15.25V12.625H4.75V15.25H15.25V12.625H17V15.25C17 15.7312 16.8286 16.1432 16.4859 16.4859C16.1432 16.8286 15.7312 17 15.25 17H4.75Z"
        fill="white"
      />
    </g>
  </svg>
);
